export const SITE = {
  name: "SolarArk Australia",
  base: "https://www.solarark.com.au",
  defaultImage: "https://www.solarark.com.au/og-image.jpg",
  phone: "1300 670 966",
  email: "info@solarark.com.au",
};

export const Seo = ({ title, description, path = "/", image, type = "website", jsonLd }) => {
  const fullTitle = title ? `${title} | ${SITE.name}` : `${SITE.name} — Solar Hot Water & Roof Ventilation`;
  const url = `${SITE.base}${path}`;
  const img = image || SITE.defaultImage;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />

      {blocks.map((block, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(block) }}
        />
      ))}
    </>
  );
};

export const organizationLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "SolarArk Australia Pty Limited",
  url: SITE.base,
  logo: `${SITE.base}/solarark-white.png`,
  foundingDate: "2009",
  description: "Australian manufacturer of solar hot water systems and solar roof ventilation.",
  sameAs: ["https://www.facebook.com/solarark/", "https://www.linkedin.com/company/solarark", "https://au.pinterest.com/lachlan3349/"],
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+61 1300 670 966",
    contactType: "sales",
    areaServed: "AU",
    email: SITE.email,
  },
};

export const localBusinessLd = {
  "@context": "https://schema.org",
  "@type": "HomeAndConstructionBusiness",
  name: "SolarArk Australia",
  image: SITE.defaultImage,
  url: SITE.base,
  telephone: "+61 1300 670 966",
  email: SITE.email,
  areaServed: "Australia",
  address: [
    { "@type": "PostalAddress", streetAddress: "7A / 59 Vicars St", addressLocality: "Mitchell", addressRegion: "ACT", postalCode: "2911", addressCountry: "AU" },
    { "@type": "PostalAddress", streetAddress: "Unit 2, 2–12 Knobel Court", addressLocality: "Shailer Park", addressRegion: "QLD", postalCode: "4128", addressCountry: "AU" },
  ],
};
